import { TranslocoService } from '@jsverse/transloco';

import { ChannelGroup } from '@shure/shared/angular/data-access/system-api/models';

import { buildDirectChannelName, directChannelGroups } from './sibling-channels.utility';

export interface MissingChannelNameDevice {
	features: {
		audioChannels: { id: string; group: ChannelGroup; features: { name: string } }[];
	};
}

/**
 *
 * @param device  device includes original audioChannels
 * @param channelId
 * @param transloco for translation, especially for direct channel
 * @param forDspDialog true for dsp dialog in automixer,  false for automixer channel itself
 * @returns direct channel name or automixer channel name or automixer channel's dsp dialog's title
 *
 * for direct channel(DirectOutput or DirectOutputAnalogInput type), there is no name property,  so its name is constructed from
 * its corresponding input channel(Generic, AnalogInput type).
 * for apx its direct channel name in this format:  "${input channel name} + (Direct)"
 * also for automixer channel,  its channel name could be empty or "Channel Mix 0",  it will be mapped
 * to "Automix Out" for channel strip and "Automixer" for dsp title  depending on flg forDspDialog
 * for normal channel, just return its own channel name
 */
export function buildChannelNameForMissingNameChannel(
	device: MissingChannelNameDevice,
	channelId: string,
	transloco: TranslocoService,
	forDspDialog = true
): string {
	const foundChannel = device.features.audioChannels.find((c) => c.id === channelId);
	if (!foundChannel) {
		return '';
	}
	// for automixer
	if (foundChannel.group === ChannelGroup.Automix) {
		if (!foundChannel.features.name || foundChannel.features.name === 'Channel Mix 0') {
			return forDspDialog ? 'Automixer' : 'Automix Out';
		}
		return foundChannel.features.name;
	}
	// for direct channels
	if (directChannelGroups.includes(foundChannel.group)) {
		return buildDirectChannelName(device, channelId, transloco);
	}

	return foundChannel.features.name ?? '';
}
